module.exports = __webpack_public_path__ + "img/celva.3ef9e7fb.svg";